
import Block from 'Mixins/Block';
import q from 'Utils/q';
import Swiper from 'Libs/swiper/swiper.min';

export default Block('component-modal', {
	fn: {
		initModal (data) {
			var slideItems = '',
				modalContent = '';

			if (data.length > 0 && typeof(data) === 'object' ) {

				for (const element of data) {

					const title =  element.querySelector('.global__media-wrapper-title') !== null ? element.querySelector('.global__media-wrapper-title').innerHTML : '';
					const caption =  element.querySelector('.global__media-wrapper-caption') !== null ? element.querySelector('.global__media-wrapper-caption').innerHTML : '';
					let mediaItem = null;
					const img =  element.querySelector('img');
					const video =  element.querySelector('video');

					// eslint-disable-next-line max-depth
					if (img !== null) {
						mediaItem = `
						<div class="component-modal__media">
							<img src="${img.src}" alt="${img.alt}" />
						</div>
						<div class="component-modal__text">
							<span class="component-modal__title global__font-caption">${title}</span>
							${caption}
						</div>
							
						
						`;
					} else if(video !== null) {
						mediaItem = `
						<div class="swiper-slide-img-wrapper">
							<div class="swiper-slide-img-inner">
								<video controls src="${video.src}" />
								<div class="swiper-slide-caption ">
									${caption}
									<p>Lorem ipsum. Lorem ipsum. Lorem ipsum.</p>
								</div>
							</div>
						</div>
						`;
					}

					slideItems += `
						<div class="swiper-slide">
							<div class="swiper-slide-inner">
								${mediaItem}
							</div>
						</div>
					`;

				}

				modalContent = `
					<div class="component-modal__slider">
						<div class="swiper-container">
							<div class="swiper-wrapper">
								${slideItems}
							</div>
						</div>
						<div class="component-slider__controller-wrapper">
							<div class="swiper-pagination"></div>
							<div class="component-slider__controller-next-prev">
								<button type="button" class="component-button component-button--round component-button--reverse component-button--action swiper-button-prev">
									<svg xmlns="http://www.w3.org/2000/svg">
										<use xlink:href="${FMV_PRESET.path.ui}icons/icons.svg#icon-arrow-right"></use>
									</svg>
								</button>
								<button type="button" class="component-button component-button--round component-button--reverse component-button--action swiper-button-next">
									<svg xmlns="http://www.w3.org/2000/svg">
										<use xlink:href="${FMV_PRESET.path.ui}icons/icons.svg#icon-arrow-right"></use>
									</svg>
								</button>
							</div>
						</div>
					</div>
				`;

			} else if (typeof(data) === 'string') {
				modalContent = `
					<div class="component-modal__video">
						<video id="modalVideo" src="${data}" controls="" autoplay="">
					</div>			
				`;
			}

			var modalTemplate = `
				<section class="component-modal">
					<div class="component-modal__inner">
						<button type="button"  aria-label="Close" class="component-button component-button--round component-button--action component-modal__close-button">
							<svg xmlns="http://www.w3.org/2000/svg">
								<use xlink:href="${FMV_PRESET.path.ui}icons/icons.svg#icon-plus"></use>
							</svg>
						</button>
						${modalContent}
					</div>
				</section>
			`;

			document.body.insertAdjacentHTML('beforeend', modalTemplate);

			q('.component-modal__close-button').addEvent('click', () => {
				this.hideModal();
			});

		},

		hideModal () {
			let modal = document.querySelector('.component-modal');
			modal.classList.add('component-modal--hide');
			let body = document.querySelector('body');
			body.classList.remove('global__modal-active');
			this.pauseAllVideos();
		},

		showModal () {

			let modal = document.querySelector('.component-modal');
			modal.classList.remove('component-modal--hide');
			let body = document.querySelector('body');
			body.classList.add('global__modal-active');
			this.pauseAllVideos();
		},

		pauseAllVideos () {
			for (const item of q('video')) {
				item.pause();
			}
		}
	},
	onLoad () {

		const thiz 				= this;
		const allImagesWrapper 	= document.querySelectorAll('.global__media-wrapper');
		let loadedModal 		= false;
		let modalSwiper 		= null;

		for (let i = 0; i < allImagesWrapper.length; i++) {

			allImagesWrapper[i].setAttribute('data-media-id', i);

		}

		q('.global__modal-button').addEvent('click', function () {

			if (!loadedModal) {

				thiz.fn.initModal(this.dataset.videoSrc);
				loadedModal = true;

			}

			thiz.fn.showModal();

			//autoplay video
			document.getElementById('modalVideo').play();

		});

		q('.global__media-wrapper').addEvent('click', function () {

			let clikedIndex = this.dataset.mediaId;

			if (!loadedModal) {

				thiz.fn.initModal(allImagesWrapper);

				if (allImagesWrapper.length > 1) {

					const className 		= 'component-modal__slider';
					const swiperContainer 	= `.${className} .swiper-container`;
					const pagination 		= `.${className} .swiper-pagination`;
					const next 				= `.${className} .swiper-button-next`;
					const prev 				= `.${className} .swiper-button-prev`;

					modalSwiper = new Swiper(swiperContainer, {
						// loop: true,
						pagination: {
							el: pagination,
							type: 'fraction',
						},
						navigation: {
							nextEl: next,
							prevEl: prev,
						},
						initialSlide: clikedIndex,
					});

					q('.component-modal__slider .component-slider__controller-wrapper').addClass('component-slider__controller-wrapper--initialized');

				}

				loadedModal = true;

			} else if (allImagesWrapper.length > 1) {

				modalSwiper.slideTo(clikedIndex, false,false);

			}

			thiz.fn.showModal();

		});

	}
});
